import { ApiErrorResponse } from '@/services/api/client'
import { helpApi } from '@/services/api/help'
import { deleteLocalAudio, saveLocalAudio } from './useTalkAudioStore'
import { loadOfflineQueue, removeOffline } from './talkOffline'
import { loadSpeaker } from './talkSpeaker'

export function isTalkRetryable(err: unknown): boolean {
  if (err instanceof ApiErrorResponse) return err.statusCode >= 500 || err.statusCode === 0
  return true
}

export async function flushOfflineQueue(convId: string, wantTts = loadSpeaker()): Promise<{ changed: boolean; blocked: boolean }> {
  const items = await loadOfflineQueue()
  let changed = false
  for (const item of items) {
    try {
      if (item.blob) {
        const res = await helpApi.createZettelAudio(convId, item.blob, item.clientId, item.selectedZettelId, item.durationMs, wantTts)
        if (res?.message) {
          await saveLocalAudio(res.message.id, item.blob)
          await deleteLocalAudio(item.clientId)
        }
      } else if (item.text) {
        await helpApi.createZettel(convId, item.text, item.clientId, item.selectedZettelId, wantTts)
      }
      await removeOffline(item.id)
      changed = true
    } catch (e) {
      if (e instanceof ApiErrorResponse && e.detail === 'stt_disabled') {
        break
      }
      if (e instanceof ApiErrorResponse && (e.statusCode === 409 || e.statusCode === 401 || e.statusCode === 403)) {
        return { changed, blocked: e.statusCode === 409 }
      }
      if (e instanceof ApiErrorResponse && e.statusCode >= 400 && e.statusCode < 500) {
        await deleteLocalAudio(item.clientId)
        await removeOffline(item.id)
        changed = true
        continue
      }
      break
    }
  }
  return { changed, blocked: false }
}
